import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'order summary print settings modal title',
    defaultMessage: 'Order Summary Printing Setup',
    id: 'ASt4iL',
  },
  description: {
    description: 'order summary print settings modal description',
    defaultMessage: 'Choose how your Order Summary appears.',
    id: 'lEH+vB',
  },
  sortOrdersBy: {
    description: 'order summary print settings sort orders by',
    defaultMessage: 'Sort Orders By',
    id: '1pDhOi',
  },
  orderDateFirst: {
    description: 'order summary print settings sort orders by: orderDateFirst',
    defaultMessage: 'Order Date: most recent first',
    id: 'JlcdNj',
  },
  orderDateLast: {
    description: 'order summary print settings sort orders by: order Date Last',
    defaultMessage: 'Order Date: most recent last',
    id: 'ZYOhJL',
  },
  datePaidFirst: {
    description: 'order summary print settings sort orders by: date Paid First',
    defaultMessage: 'Date Paid: most recent first',
    id: 'ETzouT',
  },
  datePaidLast: {
    description: 'order summary print settings sort orders by: date Paid Last',
    defaultMessage: 'Date Paid: most recent last',
    id: 'bHaxwp',
  },
  recipientNameAsc: {
    description: 'order summary print settings sort orders by: recipient Name Ascending',
    defaultMessage: 'Recipient Name: a to z',
    id: '78c4v2',
  },
  recipientNameDesc: {
    description: 'order summary print settings sort orders by: recipient Name Descending',
    defaultMessage: 'Recipient Name: z to a',
    id: '5Yz7yw',
  },
  orderNumberAsc: {
    description: 'order summary print settings sort orders by: order Number Ascending',
    defaultMessage: 'Order Number: lowest first',
    id: 'k4f+bv',
  },
  orderNumberDesc: {
    description: 'order summary print settings sort orders by: order Number Descending',
    defaultMessage: 'Order Number: highest first',
    id: 'd/emsH',
  },
  itemSkuAsc: {
    description: 'order summary print settings sort orders by: item Sku Ascending',
    defaultMessage: 'Item SKU: a to z',
    id: 'jPx02B',
  },
  itemSkuDesc: {
    description: 'order summary print settings sort orders by: item Sku Descending',
    defaultMessage: 'Item SKU: z to a',
    id: 'vNOnvT',
  },
  itemNameAsc: {
    description: 'order summary print settings sort orders by: item Name Ascending',
    defaultMessage: 'Item Name: a to z',
    id: 'HvVvn7',
  },
  itemNameDesc: {
    description: 'order summary print settings sort orders by: item Name Descending',
    defaultMessage: 'Item Name: z to a',
    id: 'fy2KDD',
  },
  productImages: {
    description: 'order summary print settings product images',
    defaultMessage: 'Product Images',
    id: 'ZjoTSk',
  },
  hideImages: {
    description: 'order summary print settings hide product images option',
    defaultMessage: 'Hide images on the Order Summary Report',
    id: 'wmUfka',
  },
  productSkuLabel: {
    description: 'order summary print settings product sku',
    defaultMessage: 'Product SKU',
    id: 'V1xdnL',
  },
  useProductSku: {
    description: 'order summary print settings use product sku option',
    defaultMessage: 'Use the product SKU rather than the selling channel SKU',
    id: 'jyrd/b',
  },
  simpleSummaryLabel: {
    description: 'order summary print settings simple summary label',
    defaultMessage: 'Simple Summary',
    id: 'eE1xlo',
  },
  simpleSummaryOption: {
    description: 'order summary print settings simple summary option',
    defaultMessage: 'Hide details (Items Only)',
    id: 'rbnNO9',
  },
  showScanToViewBarcodeLabel: {
    description: 'order summary show scan to view barcode setting label',
    defaultMessage: '"Scan to View" Barcode',
    id: '9PdCtA',
  },
  showScanToViewBarcodeOption: {
    description: 'order summary show scan to view barcode setting option',
    defaultMessage: 'Include "Scan to View" barcode for each',
    id: 'P5p7WA',
  },
});
